import { createContext, useContext } from "react";
import axios from "axios";

const ExportContext = createContext();
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const ExportProvider = ({ children }) => {
  const downloadIntradayCSV = (type) => {
    window.open(`${BASE_URL}/api/export-csv?type=${type}`, "_blank");
  };

  const downloadIntradayExcel = (type) => {
    window.open(`${BASE_URL}/api/export-excel?type=${type}`, "_blank");
  };
  const downloadOptionCSV = (symbol, expiry) => {
    console.log("donload csv", symbol, expiry);
    window.open(
      `${BASE_URL}/api/option-chain/export-csv?symbol=${symbol}&expiry=${expiry}`,
      "_blank",
    );
  };

  const downloadOptionExcel = (symbol, expiry) => {
    console.log("donload excel", symbol, expiry);
    window.open(
      `${BASE_URL}/api/option-chain/export-excel?symbol=${symbol}&expiry=${expiry}`,
      "_blank",
    );
  };
  const saveOptionChain = async (payload) => {
    try {
      const res = await axios.post(
        `${BASE_URL}/api/option-chain/save`,
        payload,
      );

      return res.data;
    } catch (err) {
      console.error("Option chain save failed", err);
      throw err;
    }
  };
  const sendReport = async ({ type, email }) => {
    try {
      const res = await axios.post(`${BASE_URL}/api/send-report`, {
        type,
        email,
      });

      return res.data; // ✅ success
    } catch (err) {
      console.error("Email send failed:", err);
      throw err; // 🔥 important for UI handling
    }
  };

  return (
    <ExportContext.Provider
      value={{
        downloadIntradayCSV,
        downloadIntradayExcel,
        downloadOptionCSV,
        downloadOptionExcel,
        saveOptionChain,
        sendReport,
      }}
    >
      {children}
    </ExportContext.Provider>
  );
};

export const useExport = () => useContext(ExportContext);
